/* Aditional Services List
 * Created on Wed Aug 30 2017
 *
 * Copyright (c) 2017 Ubiwhere
 *
 * Authors:
 * - Hugo Fonseca <hfonseca@ubiwhere.com>
 */

import React from 'react'
import styled from 'styled-components'
import { Col } from 'react-flexbox-grid'
import { MEDIA_BASE_URL } from '../../config'

const BASE_URL = MEDIA_BASE_URL

const AditionalServices = ({ list, style }) => (
  <Wrapper style={style}>
    <Label>Condições adicionais</Label>
    <List>
      {list && list.map((item, index) =>
        <ListItem key={index}>
        <AditionalIcon src={`${BASE_URL}${item.icon}`} alt={item.name} />
        {item.name}
        </ListItem>
      )}
      {!list.length &&
        <ListItem>Sem condições adicionais.</ListItem>
      }
    </List>
  </Wrapper>
)

export default AditionalServices

const Wrapper = styled(Col)`
  text-align: left;
  display: flex;
  flex-direction: column;
  margin: 14% 0px 12px 0px;
`

const Label = styled.span`
  display: block;
  font-weight: bold;
  color: ${(props) => props.color || '#3E3E3E'};
  font-size: 14px;
  font-weight: bold;
  line-height: 14px;
  margin-bottom: 12px;
`

const List = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;
`

const AditionalIcon = styled.img`
  margin-right: 5px;
`

const ListItem = styled.li`
  font-size: 12px;
  font-weight: 600;
  line-height: 13px;
  color: #676767;
  margin-bottom: 10px;
`



// WEBPACK FOOTER //
// ./src/components/AditionalServices/index.js